import { combineClassnames } from 'app/common/presentation'

import styles from './Tooltip.module.scss'

export interface TooltipProps {
  className?: string
  message: string
}

const Tooltip = ({ className, message }: TooltipProps) => (
  <div className={combineClassnames(styles.tooltip, className)}>{message}</div>
)

export default Tooltip
